// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__1TCIS","deleteBtn":"List_deleteBtn__wcM6H","rangePicker":"List_rangePicker__w6mK3"};